import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";
import "../../Style/CreateTask.css";
import "../../Style/NewCustomer.css";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import { path_url } from "../../Config/config";
import SpeechToText from "../../AI/SpeechToText";
import { useNavigate, useLocation } from "react-router-dom";

const customerSchema = Yup.object().shape({
  duedate: Yup.string().required("Required"),
  subject: Yup.string().required("Required"),
});

export default function CreateTask({ onTaskCreated }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const [usersList, setUsersList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [leadList, setLeadList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const loggedInUserName = localStorage.getItem("name") || "—";

  useEffect(() => {
    const fetchLists = async () => {
      const adminId = localStorage.getItem("adminId");
      const token = localStorage.getItem("accessToken");
      if (!adminId || !token) return;
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const uRes = await axios.get(`${path_url}/users`, { headers, params: { adminId } });
        setUsersList(Array.isArray(uRes.data) ? uRes.data : uRes.data?.content || uRes.data?.data || []);
      } catch (err) { console.error(err); }

      try {
        const cRes = await axios.get(`${path_url}/customer/dashboard/${adminId}`, { headers });
        setCustomerList(cRes.data?.body?.customerList || []);
      } catch (err) { console.error(err); }

      try {
        const lRes = await axios.get(`${path_url}/lead/dashboard/${adminId}`, { headers });
        setLeadList(lRes.data?.body?.leadList || []);
      } catch (err) { console.error(err); }

      try {
        const vRes = await axios.get(`${path_url}/vendor/dashboard/${adminId}`, { headers });
        setVendorList(vRes.data?.body?.vendorList || []);
      } catch (err) { console.error(err); }
    };
    fetchLists();
  }, []);
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const Priority = [
    { value: "High" },
    { value: "Medium" },
    { value: "Low" },
    { value: "Critical" },
    { value: "Normal" },
    { value: "Emergency" },
    { value: "Deferred" },
  ];

  const Enum = [
    { value: "Open" },
    { value: "InProgress" },
    { value: "Pending" },
    { value: "Completed" },
    { value: "Canceled" },
    { value: "Deferred" },
    { value: "WaitingforCustomer" },
    { value: "WaitingforInternalReview" },
    { value: "Reassigned" },
    { value: "OnHold" },
    { value: "Overdue" },
    { value: "Scheduled" },
    { value: "NeedsMoreInformation" },
    { value: "Escalated" },
    { value: "Closed" },
    { value: "NotApplicable" },
  ];
  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />
        <div className="mt-2">
          <Formik
            initialValues={{
              duedate: "",
              subject: "",
              notes: "",
              assignedto: "",
              priority: "High",
              status: "Open",
              customerid: location.state?.customerId || "",
            }}
            validationSchema={customerSchema}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const token = localStorage.getItem("accessToken");
                const adminId = localStorage.getItem("adminId");
                const usercid = localStorage.getItem("adminId");
                const targetCustomerId = values.customerid || location.state?.customerId || "";
                const payload = {
                  ...values,
                  ...(targetCustomerId ? { customerid: targetCustomerId } : {}),
                  useradminid: adminId,
                  usercid: usercid,
                };
                const response = await axios.post(
                  `${path_url}/task`,
                  payload,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  },
                );
                if (
                  response.data?.statusCodeValue === 200 ||
                  response.status === 200 ||
                  response.status === 201
                ) {
                  toast.success("Task submitted successfully");
                  if (typeof onTaskCreated === "function") {
                    onTaskCreated(response.data?.body || payload);
                  }
                  setTimeout(() => {
                    navigate(-1);
                  }, 1200);
                } else {
                  toast.error(response.data?.body || "Failed to create task");
                  toast.error(response.data?.body || "Failed to create task");
                }
              } catch (errors) {
                console.error("Error creating task:", errors);
                toast.error("Failed to create task");
              }
            }}
          >
            {(formik) => (
              <form action="" onSubmit={formik.handleSubmit}>
                <fieldset>
                  <div className="col-12 d-flex justify-content-center">
                    <div className="bg-white col-11 cont">
                      <div
                        style={{ boxShadow: "0 1px 1px lightgray" }}
                        className="d-flex flexDir-column mt-2 col-12 elevation-2 mb-2 justify-content-between"
                      >
                        <p
                          style={{ color: "gray" }}
                          className=" p-1 m-0 custom-font-size"
                        >
                          <strong>Create Task</strong>
                        </p>
                        <div className="d-flex input-with-speech">
                          <input
                            id="voice-input-box"
                            type="text"
                            placeholder="Voice input displayed here..."
                            disabled
                          ></input>
                          <SpeechToText inputId="voice-input-box" />
                        </div>
                      </div>
                      {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                      <div className="d-flex flex-wrap">
                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Subject</strong>
                                <sup
                                  style={{
                                    color: "red",
                                    top: 0,
                                    fontSize: 15,
                                    lineHeight: 0,
                                    position: "relative",
                                    verticalAlign: "baseline",
                                  }}
                                >
                                  *
                                </sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Subject"
                                name="subject"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.subject}
                              />
                              {formik.touched.subject &&
                                formik.errors.subject && (
                                  <span style={{ color: "red" }}>
                                    {formik.errors.subject}
                                  </span>
                                )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Due Date:</strong>
                                <sup
                                  style={{
                                    color: "red",
                                    top: 0,
                                    fontSize: 15,
                                    lineHeight: 0,
                                    position: "relative",
                                    verticalAlign: "baseline",
                                  }}
                                >
                                  *
                                </sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 d-flex  ">
                              <div
                                className="col-12 m-0"
                                style={{
                                  paddingLeft: "2px",
                                  paddingRight: "0px",
                                }}
                              >
                                <div className="p-0 m-0 w-100  forms ">
                                  <input
                                    className="input-field date "
                                    type="date"
                                    placeholder=""
                                    name="duedate"
                                    value={formik.values.duedate}
                                    onChange={formik.handleChange}
                                  />
                                </div>
                                <div className="p-0 m-0 d-flex justify-content-center">
                                  {formik.touched.duedate &&
                                    formik.errors.duedate && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.duedate}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Priority</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="priority"
                                id="priority"
                                className="selectBox custom-select "
                              >
                                <option value="">Select Priority</option>
                                {Priority.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.value}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                          <div className="col-12 col-sm-12 d-flex  mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Status</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="status"
                                id="status"
                                className="selectBox custom-select "
                              >
                                <option value="">Select Status</option>
                                {Enum.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.value}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                          {/* <div className="border col-12 ml-1 mb-3"></div> */}
                        </div>

                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Assigned To </strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field
                                as="select"
                                name="assignedto"
                                id="assignedto"
                                className="selectBox custom-select "
                              >
                                <option value="">Select User</option>
                                {usersList.map((user) => (
                                  <option key={user.id} value={user.id}>
                                    {user.name || user.username || user.email}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                          <div className=" col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                              <label
                                htmlFor=""
                                className="m-0 p-0 text-right"
                                style={{ fontSize: 15 }}
                              >
                                <strong>Notes</strong>
                              </label>
                            </div>

                            <div className="col-12 col-sm-8  forms">
                              <textarea
                                type="text"
                                id="notes"
                                name="notes"
                                rows={5}
                                placeholder="Notes"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.notes}
                              />
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label className="m-0 p-0 text-right" style={{ fontSize: 15 }}>
                                <strong>Customer</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field as="select" name="customerid" className="selectBox custom-select ">
                                <option value="">Select Customer (Optional)</option>
                                {customerList.map((c) => (
                                  <option key={c.id} value={c.id}>{c.firstname} {c.lastname}</option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label className="m-0 p-0 text-right" style={{ fontSize: 15 }}>
                                <strong>Lead</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field as="select" name="leadid" className="selectBox custom-select ">
                                <option value="">Select Lead (Optional)</option>
                                {leadList.map((l) => (
                                  <option key={l.id} value={l.id}>{l.firstname} {l.lastname}</option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label className="m-0 p-0 text-right" style={{ fontSize: 15 }}>
                                <strong>Vendor</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field as="select" name="vendorid" className="selectBox custom-select ">
                                <option value="">Select Vendor (Optional)</option>
                                {vendorList.map((v) => (
                                  <option key={v.id} value={v.id}>{v.firstname} {v.lastname}</option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label className="m-0 p-0 text-right" style={{ fontSize: 15 }}>
                                <strong>Created By</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 d-flex align-items-center">
                              <span style={{ fontSize: 15 }}>{loggedInUserName}</span>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 justify-content-end text-right-lg ">
                              <label className="m-0 p-0 text-right" style={{ fontSize: 15 }}>
                                <strong>Creation Date</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 d-flex align-items-center">
                              <span style={{ fontSize: 15 }}>{new Date().toISOString().split('T')[0]}</span>
                            </div>
                          </div>

                          <div className="col-12 d-flex justify-content-end align-items-center gap-2 p-2 mt-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-light border rounded px-4"
                              onClick={() => {
                                formik.resetForm();
                                const voiceBox = document.getElementById("voice-input-box");
                                if (voiceBox) voiceBox.value = "";
                                navigate(-1);
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              disabled={formik.isSubmitting}
                              className="btn btn-sm btn-primary rounded px-4"
                            >
                              {formik.isSubmitting ? "Saving..." : "Save"}
                            </button>
                          </div>

                          {/* <div className="border col-12 ml-1 mb-3"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            )}
          </Formik>
        </div>
        <UserFooter />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </div>
  );
}